import { render, staticRenderFns } from "./IconLinkAtom.vue?vue&type=template&id=1afeeb89&"
import script from "./IconLinkAtom.vue?vue&type=script&lang=ts&"
export * from "./IconLinkAtom.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports